import { Nature, type LigneMouvement } from '@mairistem/comptabilite';
import type { ErrorField } from '@mairistem/liste';
import PROFIL_ECRITURE from '../../../../constants/mouvements/codeProfilEcritures';
import NATURE_PIECE from '../../../../constants/mouvements/naturePiece';
import { TYPE_BORDEREAU } from '../../../../constants/mouvements/typeBordereau';
import TYPE_PIECE from '../../../../constants/mouvements/typePiece';
import BaseProfilRattachement from '../Base/BaseProfilRattachement';
import NATURE_PIECE_ORIGINE from '../../../../constants/mouvements/naturePieceOrigine';
import CodeProduitLocalPanel from '../../panel/CodeProduitLocalPanel';
import CompteDeTiersPanel from '../../panel/CompteDeTiersPanel';
import CovidPanel from '../../panel/CovidPanel';
import ProjetPanel from '../../panel/ProjetPanel';

class ProfilEcritureTravauxRegieRecette extends BaseProfilRattachement {
  constructor(anneeExercice: number) {
    super();
    this.code = PROFIL_ECRITURE.RECETTE.TRAVAUX_REGIE;
    this.typeBordereau = TYPE_BORDEREAU.RECETTE.ORDINAIRE;
    this.naturePiece = NATURE_PIECE.RECETTE.FONCTIONNEMENT;
    this.typePiece = TYPE_PIECE.RECETTE.ORDRE_BUDGET;
    this.imputation.nature = Nature.ORDRE;
    this.imputation.chapitre = '042';
    this.imputation.articles = ['722'];
    this.codesProduitLocal = ['102', '107'];
    this.naturePieceOrigine = NATURE_PIECE_ORIGINE.TITRE.MANDAT.CODE;
    this.exerRattachement = anneeExercice.toString();
    this.panels = [
      new CodeProduitLocalPanel(true),
      new CompteDeTiersPanel(),
      new CovidPanel(),
      new ProjetPanel(),
    ];
  }

  checkLigne(ligne: LigneMouvement): ErrorField[] {
    const errors: ErrorField[] = [];

    errors.push(...super.checkLigne(ligne));

    if (parseInt(ligne?.exerRattachement, 10) !== parseInt(this.exerRattachement, 10)) {
      errors.push({
        id: `ligneMouvement-exerRattachement-${ligne?.identifiant}`,
        message: "L'exercice de rattachement doit être identique à l'exercice du mouvement",
      });
    }

    if (ligne.idLigneOriginePes < 1) {
      errors.push({
        id: `ligneMouvement-idLigneOriginePes-${ligne?.identifiant}`,
        message: "L'identifiant de la ligne d'origine PES doit être supérieur ou égal à 1",
      });
    }

    return errors;
  }
}

export default ProfilEcritureTravauxRegieRecette;
